export default __webpack_public_path__ + "static/media/pharmalab.94ee83e7.jpg";